import { useState, useRef, FC } from 'react'
import { cmsDataService } from '../../services'
import { Burger, LocationPicker, MemberStatus, Navigation } from './subcomponents'
import { Logo } from '../../subcomponents'
import './header.scss'
import GlobalAnnouncementComponent from '../../components/globalAnnouncement/GlobalAnnouncementComponent'
import LocationAnnouncementComponent from '../../components/locationAnnouncement/LocationAnnouncementComponent'

export const Header: FC = () => {
    const props = cmsDataService.get().header

    const [isOpen, setIsOpen] = useState<boolean>(false)

    const headerContainer = useRef<HTMLDivElement>(null)
    const logoWrapper = useRef<HTMLDivElement>(null)
    const locationPickerWrapper = useRef<HTMLDivElement>(null)
    const signInWrapper = useRef<HTMLDivElement>(null)

    const burgerClickHandler = () => {
        setIsOpen(!isOpen)
    }

    const isOpenClass = isOpen ? 'open' : ''

    return (
        <header className={`header-wrapper`}>
            <div className={`header-container ${isOpenClass}`}>
                <div className={`header container-lg-padding`} ref={headerContainer}>
                    <div className="logo-wrapper" ref={logoWrapper}>
                        <Logo
                            link={props.headerImageLink}
                            desktopLogo={props.headerDesktopImage}
                            mobileLogo={props.headerMobileImage}
                        />
                    </div>
                    <div className="location-picker v-dropdown-location-picker" ref={locationPickerWrapper}>
                        <LocationPicker />
                    </div>
                    <Burger isOpen={isOpen} onClick={burgerClickHandler} />
                    <div className="nav-wrapper">
                        <Navigation headerContainer={headerContainer} />
                        {isOpen && <MemberStatus />}
                    </div>
                    <MemberStatus />
                </div>
            </div>

            <GlobalAnnouncementComponent />
            <LocationAnnouncementComponent />
        </header>
    )
}
